<template>
  <div class="dialogDetail">
    <div class="con">
      <div class="con-1">
        <p class="p">
          <i>影像资源：</i>
          <!-- <span class="span" v-for="val in detailInfo.studyUploadList" :key="val.studyUuid">
            {{val.accessNo}}
            <el-button size="mini"  type="primary" @click="getdimage(val.url)">预览</el-button>
          </span> -->
          <ul class="jc-list">
            <li v-for="val in detailInfo.studyUploadList" :key="val.studyUuid" @click="getdimage(val.url)">
              <div>
                <h2><img src="../../../assets/images/yx.png" class="account" alt />检查编号</h2>
                <p>{{val.accessNo}}</p>
              </div>
              <div><i class="el-icon-arrow-right" style="color:rgba(0, 0, 0, 0.4);font-weight:600"></i></div>
            </li>
          </ul>
        </p>
      </div>
    </div>
    <div class="con">
      <div class="con-1">
        <p class="p"><i>病例标题：</i><span>{{detailInfo.title}}</span></p>
        <p class="p"><i>题目难度：</i><span>{{formatterLevel('','',detailInfo.level)}}</span></p>
        <p class="p"><i>课程目录：</i><span>{{detailInfo.directoryName}}</span></p>
        <p class="p"><i>适合专业：</i><span>{{detailInfo.professionName}}</span></p>
      </div>
      <div class="con-1">
        <p class="p"><i>关键字：</i><span>{{detailInfo.keys}}</span></p>
      </div>
    </div>
    <div class="con">
      <h1 class="h1">患者申请单</h1>
      <div class="con-1">
        <p class="p">
          <i>基本信息：</i><span>患者</span>
          <span>{{detailInfo.patGender}}</span> <span>{{detailInfo.patAge}}</span></p>
        <!-- <p class="p"><i>性别：</i><span>{{detailInfo.patGender}}</span></p>
        <p class="p"><i>年龄：</i><span>{{detailInfo.patAge}}</span></p> -->
      </div>
      <div><p class="p long"><i>检查部位：</i><span>{{detailInfo.checkPoint}}</span></p></div>
      <div><p class="p long"><i>临床诊断：</i><span>{{detailInfo.clinic}}</span></p></div>
      <div><p class="p long"><i>检查目的：</i><span>{{detailInfo.studyDest}}</span></p></div>
      <div><p class="p long"><i>病例摘要：</i><span>{{detailInfo.clinicDiagnosis}}</span></p></div>
    </div>
    <div class="con">
      <h1 class="h1">报告详情单</h1>
      <div class="con-2">
        <p class="p"><i class="i-diy-width">检查类型：</i><span>{{detailInfo.modality}}</span></p>
        <p class="p"><i>检查项目：</i><span>{{detailInfo.examItem}}</span></p>
      </div>
      <div><p class="p"><i class="i-diy-width">影像学表现：</i><span>{{detailInfo.finding}}</span></p></div>
      <div><p class="p"><i class="i-diy-width">诊断：</i><span>{{detailInfo.conclusion}}</span></p></div>
      <div><p class="p"><i class="i-diy-width">影像学表现关键字：</i><span>{{detailInfo.findingKeys}}</span></p></div>
      <div><p class="p"><i class="i-diy-width">诊断关键字：</i><span>{{detailInfo.conclusionKeys}}</span></p></div>
    </div>
    <div class="con">
      <h1 class="h1">病理报告</h1>
      <div><p class="p long"><i>病理诊断：</i><span>{{detailInfo.caseDiagnosis}}</span></p></div>
      <div><p class="p long"><i>病理解析：</i><span>{{detailInfo.caseAnalysis}}</span></p></div>
      <div style="overflow: hidden;margin-top: 10px;">
        <div class="p long">
          <div class="con-img" v-for="(v, index) in contentImage" :key="v.key" @click="openImageBox(contentImage,index)">
            <img :src="v.fileUrl" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="con">
      <div class="con-1">
        <p class="p">
          <i>链接地址：</i><span>{{$dimage + `/caseDataPage?studyId=${this.studyId}`}}</span>
          <el-button @click="copy" type="primary" size="small" style="margin-left:12px">复制
            <!-- <i class="el-icon-copy-document" style="color:#409EFF;font-size:16px;"></i> -->
          </el-button>
        </p>
      </div>
    </div>
    <image-box ref="imageBox" style="z-index:3000"></image-box>
  </div>
</template>

<script>
import imageBox from '@/components/imageBox';
import { caseServer } from '@/api/api'
import formatter from '@/mixin/formatter.js';
export default {
  components: {imageBox},
  mixins: [formatter],
  data () {
    return {
      detailInfo: '',
      studyId: '',
      contentImage: []
    }
  },
  methods: {
    getData (res) {
      this.detailInfo = res
    },
    // 报告详情
    getDetail (studyId) {
      this.studyId = studyId
      this.contentImage = [];
      caseServer.caseDetail({
        studyId
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.detailInfo = data
          this.getfileurl(data.caseImgs, 'contentImage');
        } else {
          this.$message.error(message)
        }
      })
    },
    // 查看影像
    getdimage (url) {
      window.open(this.$dimage + url, '_blank')
    },
    copy () {
      // let copyText = `/caseDataPage?studyId=${this.studyId}`;
      const resolved = this.$router.resolve({
        path: '/caseDataPage',
        query: { studyId: this.studyId }
      });
      if (resolved.href) {
        this.$copyText(`${this.$dimage + '/' + resolved.href}`).then(() => {
          this.$message.success('复制成功');
          // window.open(resolved.href, '_blank');
        }, () => {
          this.$message.error('您的浏览器不支持快捷复制');
        });
        return;
      }
      this.$message.error('暂无内容可复制')
    },
    formatLevel (level) {
      switch (level) {
        case 1:
          return '容易'
        case 2:
          return '中等'
        case 3:
          return '困难'
      }
    },
    closeFun () {
      this.$emit('update', false);
    },
    getfileurl (fileKeys, prop) {
      if (!fileKeys) {
        return
      }
      if (fileKeys.length) {
        if (Array.isArray(fileKeys)) {
          this[prop] = fileKeys.map(v => { return {...v, key: v.key}})
        } else {
          this[prop] = fileKeys.split(',').map(v => { return {key: v}})
        }
        this.$getUrl({
          fileKeys: Array.isArray(fileKeys) ? fileKeys.map(v => v.key).join() : fileKeys
        }).then(obj => {
          if (obj) {
            this[prop].forEach((e) => {
              if (e) {
                this.$set(e, 'fileUrl', obj[e.key] || '')
              }
            })
          }
        })
      }
    },
    openImageBox (list, index) {
      if (this.$refs.imageBox) {
        let imageList = []
        if (list.fileUrl) {
          imageList.push({ url: `${list.fileUrl}` })
        } else {
          for (let i = 0, length = list.length; i < length; i++) {
            imageList.push({ url: `${list[i].fileUrl}` })
          }
        }
        this.$refs.imageBox.$emit('open', {
          imageList: imageList,
          index: list.fileUrl ? 0 : index // 问题区图片只有一张 下标传0
        })
      }
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">
.dialogDetail {
  position: relative;
}
/deep/ .el-dialog{
  height: calc(100% - 90px);
}
/deep/ .el-dialog__body {
  height: calc(100% - 105px);
  max-height: 100%;
}
.con {
  background: #f5f6fa;
  margin-bottom: 20px;
  padding: 20px;
  text-align: left;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 15px;
  .h1{
    color: #333;
    font-size: 15px;
    margin-bottom: 10px;
  }
  .con-1, .con-2{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    p {
      display: inline-block;
      .jc-list {
        display: flex;
        gap: 16px 8px;
        flex-wrap: wrap;
        margin-top: 8px;
        li {
          width: 234px;
          height: 72px;
          padding: 10px 24px;
          background: #FAFBFE;
          border-radius: 16px;
          border: 2px solid #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          h2 {
            margin-bottom: 4px;
            font-size: 16px;
            color: #3D3D3D;
            img {
              width: 24px;
              height: 24px;
              vertical-align: middle;
              margin-right: 8px;
            }
          }
          p {
            color: #3D3D3D;
          }
        }
      }
      .span {
        display: inline-block;
        margin-right: 12px;
      }
    }
  }
  .con-2{
    justify-content: start;
    .p{
      width: 30%;
    }
  }
  .p{
    display: flex;
    justify-content: start;
    i{
      display: inline-block;
    }
    span{
      display: inline-block;
    }
    .i-diy-width{
      width: 138px;
      /* text-align: right; */
    }
    .i-diy-width +span{
      width: calc(100% - 150px);
    }
  }
  .long{
    position: relative;
    padding-left: 78px;
    min-height: 22px;
    i{
      position: absolute;
      left: 0;
    }
  }
  .con-img {
    width: 148px;
    height: 148px;
    float: left;
    margin-right: 10px;
    margin-bottom: 25px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/resource/details/casedetail.vue